import { css } from "@emotion/react";

import { Avatar } from "components/shared/library/Avatar";
import { ButtonLink } from "components/shared/library/ButtonLink";
import { Typography } from "components/shared/library/Typography";

import { getSignUpUrl } from "utils/urls";

import { white } from "constants/colors";

const style = {
  wrapper: css({
    background: white,
    borderRadius: 16,
    padding: 24,
    display: "flex",
    width: "-webkit-fill-available",
    gap: 24,
  }),
  main: css({
    display: "flex",
    flexDirection: "column",
    gap: 8,
  }),
};

export const SignUpWidget = () => {
  return (
    <div css={style.wrapper}>
      <Avatar size={80} />
      <div css={style.main}>
        <Typography size="L" weight="bold">
          Join Ribbon to apply to this job
        </Typography>
        <Typography size="S">
          Unlock one-click personalized cover letters, job insights, and more.
        </Typography>
        <ButtonLink size="medium" href={getSignUpUrl({})}>
          Get started for free
        </ButtonLink>
      </div>
    </div>
  );
};
